
// src/components/ProfitabilityValuationMetrics.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const ProfitabilityValuationMetrics = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'ROE %': 'N/A',
    'ROA %': 'N/A',
    'ROIC %': 'N/A',
    'ROCE %': 'N/A',
    'FCF Yield %': 'N/A',
    'Dividend Payout %': 'N/A',
    'FCF / Sales %': 'N/A',
    'Sustainable Growth Rate %': 'N/A',
    'Operating Cash Flow Margin %': 'N/A',
    'Economic Value Added': 'N/A',
    'CapEx Coverage': 'N/A',
    'R&D Efficiency': 'N/A',
  };

  const keyMap = {
    'ROE %': 'roePct',
    'ROA %': 'roaPct',
    'ROIC %': 'roicPct',
    'ROCE %': 'rocePct',
    'FCF Yield %': 'fcfYieldPct',
    'Dividend Payout %': 'dividendPayoutRatioPct',
    'FCF / Sales %': 'fcfSalesPct',
    'Sustainable Growth Rate %': 'sustainableGrowthRatePct',
    'Operating Cash Flow Margin %': 'opCashFlowMarginPct',
    'Economic Value Added': 'economicValueAdded',
    'CapEx Coverage': 'capexCoverage',
    'R&D Efficiency': 'rndEfficiency',
  };

  const displayMetrics = {};
  Object.entries(defaultMetrics).forEach(([label, fallback]) => {
    const backendKey = keyMap[label];
    const value = backendKey && metricsData ? metricsData[backendKey] : null;
    displayMetrics[label] = value !== undefined && value !== null ? value : fallback;
  });

  return (
    <div className="w-full my-4">
      <div className="card p-5 min-h-[625px]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-advanced-profit rounded-full" />
          <h2 className="section-heading">
            Profitability | Valuation{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((label, index) => {
            const defKey = keyMap[label];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-advanced-profit-light border border-teal-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${label}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {label}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-advanced-profit-dark text-right break-words">
                  {formatNumber(label, displayMetrics[label], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProfitabilityValuationMetrics;


